import { lazy } from 'react';
import { Navigate, Route } from 'react-router-dom';

import { lazyRetry } from 'utils/lazy';
import { PathName } from './paths';

const Login = lazy(() => lazyRetry(() => import('pages/Login')));
const CreateNewPassword = lazy(() => lazyRetry(() => import('pages/CreateNewPassword')));
const ForgotPassword = lazy(() => lazyRetry(() => import('pages/ForgotPassword')));
const VerifyEmail = lazy(() => lazyRetry(() => import('pages/VerifyEmail')));
const ConfirmAccount = lazy(() => lazyRetry(() => import('pages/ConfirmAccount')));
const VerifyYourIdentity = lazy(() => lazyRetry(() => import('pages/VerifyYourIdentity')));
const WorkOSCallback = lazy(() => lazyRetry(() => import('pages/WorkOSCallback')));
const VerifyIdentity = lazy(() => lazyRetry(() => import('pages/VerifyIdentity')));

export const getAuthRoutes = () => (
  <>
    <Route element={<VerifyYourIdentity />} path={PathName.VerifyYourIdentity} />
    <Route element={<Login />} path={PathName.Login} />
    <Route element={<CreateNewPassword />} path={PathName.CreateNewPassword} />
    <Route element={<ForgotPassword />} path={PathName.ForgotPassword} />
    <Route
      element={<Navigate to={PathName.CreateAppointment} replace />}
      path={PathName.CreateFreeAccount}
    />
    {/*<Route element={<CreateFreeAccount />} path={PathName.CreateFreeAccount} />*/}
    <Route element={<VerifyEmail />} path={PathName.VerifyEmail} />
    <Route element={<ConfirmAccount />} path={PathName.ConfirmAccount} />
    <Route element={<WorkOSCallback />} path={PathName.WorkOSCallback} />
    <Route element={<VerifyIdentity />} path={PathName.VerifyIdentity} />
  </>
);
